module.exports = __webpack_public_path__ + "static/mbf_v3-a1467c31465b03b8cb948069f652036e.png";